import { render } from "./MatchTheBodyPart.vue?vue&type=template&id=73b84a9c&scoped=true"
import script from "./MatchTheBodyPart.vue?vue&type=script&lang=js"
export * from "./MatchTheBodyPart.vue?vue&type=script&lang=js"

import "./MatchTheBodyPart.vue?vue&type=style&index=0&id=73b84a9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b84a9c"]])

export default __exports__